// extracted by mini-css-extract-plugin
export default {"headerLinksContainer":"header-links_headerLinksContainer__g3nz0","overflowedIndicatorPopupClassName":"header-links_overflowedIndicatorPopupClassName__QDL8V"};